export default __webpack_public_path__ + "static/media/PK.cab4deb1.svg";